/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import {
  WithEventsWatchlistBtn,
  WithMoviesWatchlistBtn,
  ButtonWatchlist
} from "app/modules/watchlist";
import { useUtils, useRouter, useConfig } from "app/hooks";
import { Container, TitleWithPoster, Svg, Select, Label } from "app/components";
import {
  SectionEntityDetails,
  MainEntityDetails,
  EntityContent,
  EntityGallery,
  ListEntityInner,
  ListEntity,
  ListEntityItem,
  ListEntityFigure,
  getEventDates
} from "app/components/Entity";
import storage from "app/services/session";
import AsideMovieDetails from "./components/Aside";

import { CloseBtn } from "./styles";
import { generatePath } from "react-router-dom";

// const { NavTabsList, NavTabsItem } = NavTabs;

const WatchListEventsBtn = WithEventsWatchlistBtn(ButtonWatchlist);
const WatchlistMoviesBtn = WithMoviesWatchlistBtn(ButtonWatchlist);

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired,
  eventDetails: PropTypes.array.isRequired,
  movies: PropTypes.array.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  savedLocation: PropTypes.string.isRequired,

  getEventDetails: PropTypes.func.isRequired,
  clearErrorApi: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  getAllEvents: PropTypes.func.isRequired,
  fetchMovieOperaSessions: PropTypes.func.isRequired,
  fetchMovieOperaScreens: PropTypes.func.isRequired,
  setEventDetails: PropTypes.func.isRequired,
  setMovieOperaSessions: PropTypes.func.isRequired,
  setMovieOperaScreens: PropTypes.func.isRequired,

};

const EventDetails = ({
  match,
  eventDetails,
  movies,
  isLoggedIn,
  savedLocation,

  clearErrorApi,
  getEventDetails,
  resetState,
  getAllEvents,
  location,
  history,
  fetchMovieOperaSessions,
  fetchMovieOperaScreens,
  setEventDetails,
  setMovieOperaSessions,
  setMovieOperaScreens,
}) => {
  const [t, i18n] = useTranslation();
  const {
    location: { pathname, search, state }
  } = useRouter();
  const { routes } = useConfig();
  const { id: eventName } = match.params;
  const eventIdRef = useRef(state?.eventId);
  const MovieId = state?.movieId;
  const [display, setDisplay] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [isMainTabVisible, toggleTabs] = useState(true);

  const { getDateWithOffset } = useUtils();

  const filteredEvents = useSelector(stateValue => stateValue.events.allEvents);
  const screensData = useSelector(state => state?.cinemas?.operaScreens);
  const selectedEvent = filteredEvents?.find(
    // item => item?.eventUrlName?.replaceAll(" ", "-") === eventName
    item => {
      return item?.eventUrlName === eventName
    }
    // item => item?.title?.replaceAll(" ", "-") === eventName
  );



  // const { pathname } = location;

  const printSubTitle = (preselling, startDate) => {
    if (preselling) {
      return t("common.preselling");
    }
    if (startDate) {
      return `${t("movies.film_start")}: ${format(
        getDateWithOffset(startDate),
        "dd.MM.yyyy"
      )}`;
    }

    return null;
  };

  const {
    id,
    title,
    picture,
    isInWatchlist,
    gallery,
    shortDescription,
    longDescription,
    startDate,
    endDate,
    cinemas,
    isAbo,
    aboIds,
    aboIdArr
  } = eventDetails;



  const ID = localStorage.getItem('eventId') !== 'null' ? localStorage.getItem('eventId') : eventDetails?.id;
  // eslint-disable-next-line no-unused-vars
  const events = localStorage.getItem("events")
  const operaSessionsData = useSelector(state => state?.cinemas?.operaSessions);
  const sessionId = operaSessionsData[0]?.sessions[0]?.id;
  const data = JSON.parse(events)
  const getEventId = data?.find((item) => {
    // const formattedEventName = item.eventUrlName.replaceAll("-", " ").replaceAll(" ", "-").toLowerCase();
    const formattedEventName = item.eventUrlName.toLowerCase();
    // const formattedPathname = window?.location?.pathname?.split("/")[2]?.replaceAll("-", " ").replaceAll(" ", "-").toLowerCase();
    const formattedPathname = window?.location?.pathname?.split("/")[2].toLowerCase();
    // if (window?.location?.pathname?.split("/")[2]?.replaceAll("-", " ") === item?.eventUrlName) {
    if (formattedEventName === formattedPathname) {
      return item.id;
    }
  })
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedScreensOption, setSelectedScreensOption] = useState('');

  const key = selectedScreensOption[0]?.value?.split('-');
  const AboIds = key && key[1];

  useEffect(() => {
    setEventDetails({});
    setMovieOperaSessions([]);
    setMovieOperaScreens([]);
  }, [])
  useEffect(() => {
    const data = screensData?.map(cinema => ({
      label: cinema.screenName,
      value: cinema.promotionId
    }))
    setOptions(data)
  }, [screensData])
  const handleOptionChange = (event) => {
    const selectedValue = event;
    setSelectedOption(selectedValue);
  };
  const handleOptionScreensChange = (event) => {
    const selectedValue = event;
    setSelectedScreensOption(selectedValue);
  };
  const getStateOptions = useCallback(() => {
    return cinemas?.map(({ id, name }) => ({ label: name, value: id }));
  }, [cinemas]);

  const getScreensOptions = useCallback(() => {
    return screensData?.map(({ promotionId, screenName }) => ({ label: screenName, value: promotionId }));
  }, [screensData]);
  // localStorage.setItem('eventId', getEventId?.id || sessionStorage.getItem("movie"));
  useEffect(() => {
    if (localStorage.getItem('eventId') === null && eventDetails?.eventUrlName) {
      localStorage.setItem('eventId', JSON.stringify(eventDetails?.eventUrlName))
    }
    else if (localStorage.getItem('eventId') !== eventDetails?.eventUrlName) {
      localStorage.setItem('eventId', JSON.stringify(eventDetails?.eventUrlName))
    }
  }, [eventDetails?.id])

  const findId = { id: MovieId }

  useEffect(() => {
    setTimeout(() => {
      setDisplay(true)
    }, 600)

    localStorage.removeItem("selectMovieId");
  }, [events])

  useEffect(() => {
    if (state?.eventId || selectedEvent?.id || ID) {
      eventIdRef.current = state?.eventId || selectedEvent?.id || ID;
    }
    // else {
    //   getAllEvents();
    // }
  }, [state, selectedEvent, i18n, ID]);

  useEffect(() => {
    if (process.env.REACT_APP_COUNTRY === "svn") {
      document.title = "Cineplexx | Dogodek"
    }

    return () => {
      document.title = "Cineplexx"
    };
  }, [])


  // useEffect(() => {
  //   if (MovieId !== undefined) {
  //     getEventDetails(findId?.id);
  //   } else if (state?.eventId && state?.eventId !== '') {
  //     getEventDetails(state?.eventId);
  //   } else if (selectedEvent?.id && selectedEvent?.id !== '') {
  //     getEventDetails(findId?.id || selectedEvent?.id);
  //   } else if (getEventId?.id && getEventId?.id !== '') {
  //     getEventDetails(getEventId?.id)
  //   } else if (ID && ID !== '' && ID !== 'null' && ID !== 'undefined') {
  //     getEventDetails(ID)
  //   } else {
  //     getAllEvents();
  //   }
  // }, [i18n, state?.eventId, selectedEvent?.id, getEventId?.id, ID]);

  useEffect(() => {
    getEventDetails(eventName);
  }, [])
  useEffect(() => {
    if (isAbo && selectedOption[0]?.value && !key) {
      const cinemaId = selectedOption[0]?.value;
      fetchMovieOperaScreens(cinemaId);
    }
    else if (key && selectedScreensOption[0]?.value) {
      const cinemaId = key[0];
      fetchMovieOperaSessions(cinemaId, AboIds);
    }
  }, [isAbo, selectedOption, selectedScreensOption]);
  // useEffect(() => {
  //   if (selectedEvent?.id) {
  //     getEventDetails(findId?.id || selectedEvent?.id);
  //   } else {
  //     getEventDetails(ID)
  //   }
  // }, [selectedEvent, i18n])

  useEffect(() => {
    if (eventDetails?.eventUrlName?.length > 0) {
      // let ArraySplit = eventDetails?.eventUrlName?.replaceAll(' ', '-')?.replaceAll('/', '-').split(" ");
      const ArraySplit = eventDetails?.eventUrlName?.split(" ");
      // let slug = ArraySplit.join("-");

      const slug = ArraySplit.join(" ");

      const base_url = window.location.origin;

      const dynamicUrl = `${base_url}/${process.env.REACT_APP_COUNTRY === "svn" ? 'dogodki' : 'events'}/${slug}`;

      if (window.location.href !== dynamicUrl) {
        if (eventDetails?.id === findId?.id || eventDetails?.id === +ID || eventDetails?.id === getEventId?.id) {
          if (!window.location.href.includes("%22")) {
            window.location.replace(dynamicUrl)
          }
        }
      }
    }
  }, [eventDetails?.eventUrlName]);

  useEffect(() => {
    if (MovieId !== undefined) {
      storage.setMovieId(MovieId);
    }
  }, [])

  const dates = getEventDates(startDate, endDate, getDateWithOffset);
  const entitycontent = useRef(null);


  const [src, setSrc] = useState(null);
  const [popup, setPopUp] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const entityContentEl = document.getElementById("entity-content");

      if ((entitycontent.current || entityContentEl) && longDescription) {
        const images = entitycontent ?
          entitycontent.current.querySelectorAll("img[alt='asset_image']") :
          entityContentEl.querySelectorAll("img[alt='asset_image']");
        // entitycontent.current.querySelectorAll("img[pimcore_disable_thumbnail='true']") :
        // entityContentEl.querySelectorAll("img[pimcore_disable_thumbnail='true']");

        images.forEach(img => {
          const src = img.getAttribute("src")

          img.addEventListener("click", (e) => {
            setSrc(src);
            setPopUp(true);
          })
        })
      }
    }, 500);
  }, [entitycontent, longDescription])


  useEffect(() => {
    const selectedOptionObj = options?.find(opt => {
      return opt?.value === selectedScreensOption[0]?.value
    });
    if (selectedOptionObj && sessionId) {
      history.push({
        pathname: generatePath(routes.wizard.pattern, { movieCinemaId: sessionId }),
        state: {
          route: `${pathname}${search}`,
          isAboId: isAbo ? isAbo : null,
          aboId: AboIds ? AboIds : null,
          operaSessionsData: operaSessionsData,
        }
      });
    }
  }, [sessionId])

  return (
    <>
      {display && <SectionEntityDetails>
        {/*
          <div className="s-entity-details__nav-tabs">
            <NavTabsList>
              <NavTabsItem
                isSelected={isMainTabVisible}
                onClick={() => toggleTabs(true)}
                text={t("movies.showtimes")}
              />
              <NavTabsItem
                isSelected={!isMainTabVisible}
                onClick={() => toggleTabs(false)}
                text={t("movies.movie_details")}
              />
            </NavTabsList>
          </div>
        */}

        <Container>
          <MainEntityDetails isVisible={isMainTabVisible}>
            {id ? (
              <Fragment>
                <TitleWithPoster
                  entityDetails={eventDetails}
                  location={null}
                  withEvent={{ dates }}
                >
                  {isLoggedIn ? (
                    <WatchListEventsBtn
                      id={id}
                      isInWatchList={isInWatchlist}
                      isDetails
                    />
                  ) : null}
                </TitleWithPoster>

                {gallery && gallery.length ? (
                  <EntityGallery gallery={gallery} />
                ) : null}

                {
                  isAbo ? (
                    <>
                      <div className="f-default__field firstName" style={{
                        margin: '10px 0'
                      }}>
                        <Label htmlFor="state">{t("common.cinema")}</Label>
                        <Select
                          placeholder={t("common.choose")}
                          options={getStateOptions()}
                          name="state"
                          value={selectedOption}
                          onChange={handleOptionChange}
                        />
                      </div>
                    </>
                  ) : null
                }
                {
                  screensData?.length > 0 ? (
                    <>
                      <div className="f-default__field firstName" style={{
                        margin: '10px 0'
                      }}>
                        <Label htmlFor="screen">{screensData?.length === 1 ? t("common.hall") : t("common.halls")}</Label>
                        <Select
                          placeholder={t("common.choose")}
                          options={getScreensOptions()}
                          name="screen"
                          value={selectedScreensOption}
                          onChange={handleOptionScreensChange}
                        />
                      </div>
                    </>
                  ) : null
                }
              </Fragment>
            ) : null}

            {movies.length ? (
              <EntityContent>
                <h5 className="b-entity-content__title">{t("common.films")}</h5>
                <ListEntity withSmallPadding>
                  {movies.map(movie => {
                    return (
                      <ListEntityItem
                        key={movie?.id}
                        withSmallPadding
                        onClick={() => sessionStorage.setItem("seletEventMovieId", movie?.id)}
                      >
                        <ListEntityFigure>
                          <ListEntityInner
                            title={movie.titleCalculated}
                            subTitle={printSubTitle(
                              // movie.preselling,
                              null,
                              movie.startDate
                            )}
                            poster={movie.posterImage}
                            to={movie}
                            pathnameSlug={pathname}
                          />
                          {isLoggedIn ? (
                            <WatchlistMoviesBtn
                              id={movie.id}
                              isInWatchList={movie.isInWatchlist}
                            />
                          ) : null}
                        </ListEntityFigure>
                      </ListEntityItem>
                    );
                  })}
                </ListEntity>
              </EntityContent>
            ) : null}

            {longDescription ? (
              <>
                <EntityContent>
                  <h5 className="b-entity-content__title">
                    {t("common.description")}
                  </h5>
                  <div
                    className="b-entity-content__text"
                    id="entity-content"
                    ref={entitycontent}
                    dangerouslySetInnerHTML={{ __html: longDescription }}
                  />
                  {popup && src && (
                    <div
                      className="screen-popup"
                      onClick={() => {
                        setPopUp(false);
                        setSrc(null);
                      }}
                    >
                      <div>
                        <div className="close-btn">
                          <CloseBtn >
                            <Svg id="close" />
                          </CloseBtn>
                        </div>
                        <img src={src} alt="screen-1" />
                      </div>
                    </div>
                  )}
                </EntityContent>
              </>
            ) : null}
          </MainEntityDetails>
          {picture && (
            <AsideMovieDetails
              title={title}
              shortDescription={shortDescription}
              picture={picture}
              isVisible={!isMainTabVisible}
            />
          )}
        </Container>
      </SectionEntityDetails>}
    </>
  );
};

EventDetails.propTypes = propTypes;
export default EventDetails;
